<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card  p-shadow-1">
				<h5>Feriados</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">
						<Dropdown v-model="anoSelecionado" :options="anos" optionLabel="name" optionValue="name" class="p-mr-5" @change="listar"/>
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="exibirModalNovo" v-if="permissaoNovo"/>
						<Button type="button" icon="pi pi-copy" label="Copiar feriados" @click="exibirDialogCopiar = true" v-if="permissaoNovo"/>
					</template>
				</Toolbar>		

				<DataTable :value="feriados" :filters="filtro" class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="data" header="Data" sortable>		
						<template #body="slotProps">
							{{ formatarStringData(slotProps.data.data) }}
						</template>				
					</Column>
					<Column field="descricao" header="Descrição" sortable></Column>
					<Column field="abrangencia" header="Abrangência" sortable></Column>
					<Column field="estado" header="Estado" sortable></Column>
					<Column field="cidade" header="Cidade" sortable></Column>
					<Column field="tipo" header="Tipo" dateFormat="dd/mm/yy" sortable></Column>
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="exibirDialogNovo" :header="tituloModal" :modal="true" :style="{width: '50vw'}" @hide="fecharModal">					
					<TabView>							
						<TabPanel header="Feriado">		
							<div class="p-fluid p-formgrid p-grid">
								<div class="p-field p-col-12 p-md-4">
									<label for="data">Data</label>							
									<Calendar id="data" v-model="feriadoSelecionado.data" :showIcon="true" :manualInput="false" required="true" dateFormat="dd/mm/yy" appendTo="body"/>
									<small class="p-invalid" v-if="enviandoForm && !feriadoSelecionado.data">Selecione uma data</small>
								</div>
								<div class="p-field p-col-12 p-md-8">
									<label for="descricao">Descrição</label>
									<InputText id="descricao" v-model.trim="feriadoSelecionado.descricao" required="true" />
									<small class="p-invalid" v-if="enviandoForm && !feriadoSelecionado.descricao">Informe a descrição</small>
								</div>
							</div>
							<div class="p-fluid p-formgrid p-grid p-mb-2">
								<div class="p-field p-col-12 p-md-4">
									<label for="estado">Estado</label>							
									<Dropdown id="estado" @change="listarCidades" v-model="feriadoSelecionado.estado.id" required="true" appendTo="body"
										:options="estados" optionLabel="uf" optionValue="id" placeholder="Selecione" :filter="true" :showClear="true"/>
									<small class="p-invalid" v-if="enviandoForm && !feriadoSelecionado.estado.id">Selecione um estado</small>
								</div>
								<div class="p-field p-col-12 p-md-8">
									<label for="cidade">Cidade</label>							
									<Dropdown id="cidade" v-model="feriadoSelecionado.cidade.id" :options="cidades" required="true" appendTo="body"
										optionLabel="nome" optionValue="id" placeholder="Selecione" :filter="true" :showClear="true"/>
									<small class="p-invalid" v-if="enviandoForm && !feriadoSelecionado.cidade.id">Selecione uma cidade</small>
								</div>
							</div>			
							<label>Abrangência</label>			
							<div class="p-formgroup-inline p-mt-2 p-mb-2">
								<div class="p-field-radiobutton">
									<RadioButton id="abrangencia1" name="abrangencia" :value="1" v-model.number="feriadoSelecionado.abrangencia"/>
									<label>Federal</label>								
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="abrangencia2" name="abrangencia" :value="2" v-model.number="feriadoSelecionado.abrangencia"/>
									<label>Estadual</label>												
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="abrangencia3" name="abrangencia" :value="3" v-model.number="feriadoSelecionado.abrangencia"/>	
									<label>Municipal</label>											
								</div>								
							</div>
							<label>Tipo</label>
							<div class="p-formgroup-inline p-mt-2 p-mb-2">								
								<div class="p-field-radiobutton">
									<RadioButton id="fixo1" name="fixo" :value="true" v-model="feriadoSelecionado.fixo" />
									<label>Fixo</label>								
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="fixo2" name="fixo" :value="false" v-model="feriadoSelecionado.fixo" />
									<label>Móvel</label>												
								</div>
							</div>								
						</TabPanel>
						<TabPanel header="Exceção da Regra" v-if="permissaoRegraExecao">
							<label>Abrangência</label>			
							<div class="p-formgroup-inline p-mt-2 p-mb-2">								
								<div class="p-field-radiobutton">
									<RadioButton id="abrangencia3" name="abrangencia" :value="4" v-model.number="feriadoSelecionado.abrangencia" @change="validarExcecaoRegra"/>	
									<label>Centro de Custo<span class="ik-text-danger"> *</span></label>											
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="abrangencia3" name="abrangencia" :value="5" v-model.number="feriadoSelecionado.abrangencia" @change="validarExcecaoRegra"/>	
									<label>Cargo<span class="ik-text-danger"> *</span></label>											
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="abrangencia3" name="abrangencia" :value="6" v-model.number="feriadoSelecionado.abrangencia" @change="validarExcecaoRegra"/>	
									<label>Global</label>											
								</div>
							</div>
							<DataTable :value="cargosCentrosCustosSelecionados" class="p-datatable-sm p-datatable-striped"
								:paginator="true" :rows="6"
								paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
								:rowsPerPageOptions="[6]"
								currentPageReportTemplate="Listando {first} a {last} de {totalRecords}">
								<template #header>
									<div class="table-header">			
										<div class="p-d-flex p-jc-start">		
											<Dropdown v-model="cnpjSelecionado" :options="cnpjs" optionLabel="refCnpj" class="p-mr-2" v-if="feriadoSelecionado.abrangencia == 4"/>		
											<Button icon="pi pi-search" label="Selecionar..." @click="buscarCargosCentrosCustos" :disabled="bloquearBotaoCargoCentroCusto"/>										
										</div>
									</div>
								</template>
								<Column field="codigo" header="Código" sortable></Column>
								<Column field="nome" header="nome" sortable></Column>							
								<Column>
									<template #body="slotProps">										
										<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="excluirCargoCentroCusto(slotProps.data)"/>
									</template>
								</Column>
							</DataTable>							
						</TabPanel>	
					</TabView>	
					<label class="ik-text-danger">{{ mensagem }}</label>			
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="salvar" />
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogCopiar" header="Copiar feriados" :modal="true" class="p-fluid">	
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col">
							<label for="anoDe">De</label>
							<InputNumber id="anoDe" v-model="anoDe" :min="1" :max="9999" required="true" mode="decimal" :useGrouping="false"/>
							<small class="p-invalid" v-if="enviandoForm && !anoDe">Informe o ano De</small>
						</div>
						<div class="p-field p-col">
							<label for="anoPara">Para</label>
							<InputNumber id="anoPara" v-model="anoPara" :min="1" :max="9999" required="true" mode="decimal" :useGrouping="false"/>
							<small class="p-invalid" v-if="enviandoForm && !anoPara">Informe o ano Para</small>
						</div>
					</div>						
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary p-mt-6" @click="exibirDialogCopiar = false"/>
						<Button label="Copiar" icon="pi pi-check" @click="copiar" />
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir feriado <b>{{ feriadoSelecionado.descricao }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogCargosCentrosCustos" header="Selecionar" :modal="true" :style="{width: '40vw'}" @hide="cancelarIncluirCargosCentrosCustos">
					<DataTable :value="cargosCentrosCustos" :selection.sync="cargosCentrosCustosPreSelecionados" 
						:paginator="true" :rows="6"
						paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
						:rowsPerPageOptions="[6]"
						currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
						class="p-datatable-sm p-datatable-striped" dataKey="id">				
						<Column selectionMode="multiple" headerStyle="width: 3em"></Column>		
						<Column field="codigo" header="Código" sortable></Column>
						<Column field="nome" header="nome" sortable></Column>	
					</DataTable>
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="cancelarIncluirCargosCentrosCustos"/>
						<Button label="Incluir" icon="pi pi-check" @click="incluirCargosCentrosCustos" :disabled="cargosCentrosCustosPreSelecionados.length == 0"/>
					</template>
				</Dialog>

			</div>
		</div>
	</div>
</template>

<script>
import FeriadoService from '@/service/FeriadoService';
import EmpresaService from '@/service/EmpresaService';
import CentroCustoService from '@/service/CentroCustoService.js';
import CargoService from '@/service/CargoService.js';
import Feriado from '@/model/Feriado';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	feriadoService: null,
	cargoService: null,
	centroCustoService: null,
	empresaService: null,
	data() {
		return {
			mensagem: '',
			tituloModal: 'Novo Feriado',
			bloquearBotaoCargoCentroCusto: true,
			permissaoNovo: false,
			permissaoEditar: false,
			permissaoExcluir: false,
			permissaoRegraExecao: false,
			exibirDialogCargosCentrosCustos: false,			
			exibirDialogConfirmarExcluir: false,
			exibirDialogNovo: false,
			exibirDialogCopiar: false,
			anoDe: null,
			anoPara: null,
			enviandoForm: false,
			feriadoSelecionado: new Feriado(),
			feriados: [],
			estados: [],
			cidades: [],
			anos:[],
			cargosCentrosCustos: [],
			cargosCentrosCustosPreSelecionados: [],
			cargosCentrosCustosSelecionados: [],
			cnpjs: [],
			cnpjSelecionado: {},
			anoSelecionado: new Date().getFullYear(),
			filtro: {},
			
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes']),		
		listar() {		
			let requisicao = {
				ano: this.anoSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.feriadoService.listar(requisicao)
				.then(resp => {
					this.feriados = resp.data;
                })
                .catch(erro => {exibirMensagem(this, erro)});   
		},
		listarCidades(event) {		
			if(event.value == null) {
				this.cidades = [];
			} else {
				this.feriadoService.listarCidades(event.value)
					.then(resp => {					
						this.cidades = resp.data;
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}			
		},
		carregarAnos() {		
			let anoInicio = this.anoSelecionado - 10;
			for(let i = 0; i < 20; i++) {			
				this.anos.push({name: (anoInicio + i), code: (anoInicio + i)});
			}
		},
		exibirModalNovo() {
			this.feriadoService.listarEstados()
				.then(resp => {					
					this.estados = resp.data;
					this.feriadoSelecionado = new Feriado();
					this.tituloModal = 'Novo Feriado';
					this.exibirDialogNovo = true;
					this.enviandoForm = false;
				})
				.catch(erro => {exibirMensagem(this, erro)});			
		},
		fecharModal() {		
			this.feriadoSelecionado = new Feriado();	
			this.exibirDialogNovo = false;
			this.enviandoForm = false;
			this.mensagem = '';
			this.bloquearBotaoCargoCentroCusto = true;
		},
		salvar() {			
			this.enviandoForm = true;			
			if(this.feriadoSelecionado.descricao == '' 
				|| this.feriadoSelecionado.data == null 
				|| this.feriadoSelecionado.cidade.id == null) {	
				return;						
			}	
			if((this.feriadoSelecionado.abrangencia == 4 && this.cargosCentrosCustosSelecionados.length == 0)
				|| (this.feriadoSelecionado.abrangencia == 5 && this.cargosCentrosCustosSelecionados.length == 0)) {
				return;
			}
			if(this.feriadoSelecionado.abrangencia == 4) {
				this.feriadoSelecionado.centrosCustos = this.cargosCentrosCustosSelecionados;
			}
			if(this.feriadoSelecionado.abrangencia == 5) {
				this.feriadoSelecionado.cargos = this.cargosCentrosCustosSelecionados;
			}
			let feriado = {...this.feriadoSelecionado};
			if(this.feriadoSelecionado.data instanceof Date) {
				let dt = feriado.data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				feriado.data = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = feriado.data.split('/');
				feriado.data = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			let requisicao = {
				feriado: feriado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.feriadoService.salvar(requisicao)
				.then(resp => {	
					this.fecharModal();
					this.listar();
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});		
		},
		editar(feriado) {
			this.enviandoForm = false;
			let requisicao = {
				idFeriado: feriado.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.feriadoService.buscar(requisicao)
				.then(resp => {			
					this.estados = resp.data.estados;
					this.cidades = resp.data.cidades;
					this.feriadoSelecionado = resp.data.feriado;				
					let partes = this.feriadoSelecionado.data.split('-');	
					this.feriadoSelecionado.data =partes[2] + '/' + partes[1] + '/' + partes[0];
					if(this.feriadoSelecionado.abrangencia == 4) {
						this.bloquearBotaoCargoCentroCusto = false;
						this.cargosCentrosCustosSelecionados = this.feriadoSelecionado.centrosCustos;
					} else if(this.feriadoSelecionado.abrangencia == 5) {
						this.bloquearBotaoCargoCentroCusto = false;
						this.cargosCentrosCustosSelecionados = this.feriadoSelecionado.cargos;	
					}
					this.tituloModal = 'Editar Feriado';
					this.exibirDialogNovo = true;
					this.enviandoForm = false;
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		excluir() {
			let requisicao = {
				feriado: {id: this.feriadoSelecionado.id },
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.feriadoService.excluir(requisicao)
				.then(resp => {	
					this.limparExcluir();		
					this.listar();
					exibirMensagem(this, resp);	
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		incluirCargosCentrosCustos() {
			this.cargosCentrosCustosPreSelecionados.forEach(itemSelecionado => {
				let encontrou = false;
				for(let i = 0; i < this.cargosCentrosCustosSelecionados.length; i++) {
					let item = this.cargosCentrosCustosSelecionados[i];
					if(itemSelecionado.id == item.id) {
						encontrou = true;
						break;
					}
				}
				if(!encontrou) {
					this.mensagem = '';
					this.cargosCentrosCustosSelecionados.push(itemSelecionado);
				}
			});
			this.cargosCentrosCustosPreSelecionados = [];
			this.exibirDialogCargosCentrosCustos = false;
		},
		cancelarIncluirCargosCentrosCustos() {
			this.cargosCentrosCustosPreSelecionados = [];
			this.exibirDialogCargosCentrosCustos = false;
		},
		excluirCargoCentroCusto(cargoCentroCusto) {
			for(let i = 0; i < this.cargosCentrosCustosSelecionados.length; i++) {
				let item = this.cargosCentrosCustosSelecionados[i];
				if(item.id == cargoCentroCusto.id) {
					this.cargosCentrosCustosSelecionados.splice(i, 1);
					break;
				}
			}
			if(this.cargosCentrosCustosSelecionados.length == 0) {
				if(this.feriadoSelecionado.abrangencia == 4) {
					this.mensagem = '* Selecione Centros de Custos';
				} else if(this.feriadoSelecionado.abrangencia == 5) {
					this.mensagem = '* Selecione Cargos';
				}
			}
		},
		validarExcecaoRegra() {			
			this.mensagem = '';
			this.cargosCentrosCustosSelecionados = [];
			if(this.feriadoSelecionado.abrangencia == 4) {
				if(this.feriadoSelecionado.centrosCustos.length == 0) {
					this.mensagem = '* Selecione Centros de Custos';
				}				
				this.bloquearBotaoCargoCentroCusto = false;
			} else if(this.feriadoSelecionado.abrangencia == 5) {
				if(this.feriadoSelecionado.cargos.length == 0) {
					this.mensagem = '* Selecione Cargos';
				}				
				this.bloquearBotaoCargoCentroCusto = false;
			} else {
				this.bloquearBotaoCargoCentroCusto = true;
			}
		},
		copiar() {
			this.enviandoForm = true;
			if(this.anoDe != null && this.anoDe > 0 && this.anoPara != null && this.anoPara > 0) {
				let requisicao = {
					anoDe: this.anoDe,
					anoPara: this.anoPara,
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}
				this.feriadoService.copiar(requisicao)
					.then(resp => {	
						this.anoDe = null;
						this.anoPara = null;
						this.exibirDialogCopiar = false;
						this.enviandoForm = false;
						exibirMensagem(this, resp);	
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}
		},
		listarCNPJs() {		
			this.empresaService.listarCNPJs(this.getDadosRequisicao())
				.then(resp => {
					this.cnpjs = resp.data;
					this.cnpjs.forEach(cnpj => {
						cnpj['refCnpj'] = cnpj.numero +' '+ cnpj.razaoSocial;
					});
					this.cnpjSelecionado = this.cnpjs[0];
                })
                .catch(erro => {exibirMensagem(this, erro)});   
		},
		buscarCargosCentrosCustos() {			
			if(this.feriadoSelecionado.abrangencia == 4) {
				this.listarCentrosCustos();
			} else {// 5 Cargos
				this.listarCargos();
			}
		},
		listarCentrosCustos() {
			let requisicao = {
				idCNPJ: this.cnpjSelecionado.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.centroCustoService.listarTodos(requisicao)
				.then(resp => {
					this.cargosCentrosCustos = resp.data;		
					this.cargosCentrosCustosPreSelecionados = [];
					this.exibirDialogCargosCentrosCustos = true;			
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
		},
		listarCargos() {			
			this.cargoService.listar(this.getDadosRequisicao())
				.then(resp => {
					this.cargosCentrosCustos = resp.data;		
					this.cargosCentrosCustosPreSelecionados = [];
					this.exibirDialogCargosCentrosCustos = true;			
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		limparExcluir() {
			this.feriadoSelecionado = {
				abrangencia: 1,
				fixo: true, 
				estado: {},
				cidade: {}
			};
			this.exibirDialogConfirmarExcluir = false;
		},
		confirmarExcluir(feriado) {
			this.feriadoSelecionado = feriado;
			this.exibirDialogConfirmarExcluir = true;
		},
		formatarStringData(data) {
			let partes = data.split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0];
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(34);
			this.permissaoEditar = permissoes.includes(35);
			this.permissaoExcluir = permissoes.includes(36);	
			this.permissaoRegraExecao = permissoes.includes(152);		
		}
	},
	created() {
		this.feriadoService = new FeriadoService();		
		this.empresaService = new EmpresaService();
		this.cargoService = new CargoService();
		this.centroCustoService = new CentroCustoService();
	},
	mounted() {		
		this.validarPermissoes();
		this.carregarAnos();
		this.listar();		
		this.listarCNPJs();
	}
}
</script>

<style scoped>

</style>